import { render, staticRenderFns } from "./DispatchTempCardConfirmDialog.vue?vue&type=template&id=3ecfbf3a&lang=pug"
import script from "./DispatchTempCardConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DispatchTempCardConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports